import React from 'react';
import PropTypes from 'prop-types';
import Card from 'partial/components/Card';
import Button from 'partial/components/Button';
import logo from 'assets/images/logo-horizontal.svg';
import placeholder from 'assets/images/placeholder.svg';
import { HiLockClosed, HiPencil } from 'react-icons/hi';
import FormTextArea from 'partial/form/FormTextArea';
import { BiArrowBack } from 'react-icons/bi';
// import FormInput from 'partial/form/FormInput';

function SelectedInvoice({ onGoBack }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <Button transparent icon={BiArrowBack} onClick={onGoBack}>
          Go Back
        </Button>
        <div className="flex items-center space-x-2">
          <div className="text-gray-500">Draft saved 1 second ago</div>
          <Button>Hide Preview</Button>
          <Button primary>Review Invoice</Button>
        </div>
      </div>
      <div className="grid grid-cols-5 gap-4">
        <Card className="col-span-3">
          <div className="px-7 py-5 space-y-5">
            <div className="space-y-2">
              <div className="title-h2 mb-2">Customer</div>
              <div className="text-base">John Doe</div>
              <div className="value-text">test@email.com</div>
              <div className="text-xs text-gray-500">
                Language: English (United States)
              </div>
            </div>
            <div>
              <div className="space-y-2">
                <div className="flex items-center space-x-2 justify-between">
                  <div className="title-h2 mb-2">Items</div>
                  <div className="">Collect Tax Automatically</div>
                </div>
              </div>
              <div className="divide-y">
                <div className="flex items-center justify-between space-x-2 py-3">
                  <div className="value-text">Item Number 1</div>
                  <div className="flex items-center space-x-2">
                    <div className="text-base">₱100.00</div>
                    <Button link size="xs">
                      <HiPencil className="w-4 h-4 flex-shrink-0" />
                    </Button>
                  </div>
                </div>
                <div className="flex items-center justify-between space-x-2 py-3">
                  <div className="value-text">Item Number 2</div>
                  <div className="flex items-center space-x-2">
                    <div className="text-base">₱100.00</div>
                    <Button link size="xs">
                      <HiPencil className="w-4 h-4 flex-shrink-0" />
                    </Button>
                  </div>
                </div>
                <div className="flex items-center justify-center space-x-2 py-3">
                  <Button link>Add Item</Button>
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="title-h2 mb-2">Add Memo / Note</div>
              <div className="flex items-center space-x-2">
                <div className="text-base">Thanks for your business!</div>
                <Button link size="xs">
                  <HiPencil className="w-4 h-4 flex-shrink-0" />
                </Button>
              </div>
              <div className="w-1/2">
                <FormTextArea placeholder="Thanks for your business!" />
              </div>
            </div>
            {/* <div className="space-y-2">
              <div className="title-h2 mb-2">Payment</div>
              <div className="text-base">
                Automatically charge a payment method on file
              </div>
              <div>
                <fieldset className="mt-2">
                  <legend className="sr-only">Bank account</legend>
                  <div className="divide-y divide-gray-200">
                    <div className="relative flex items-start py-4">
                      <div className="min-w-0 flex-1 text-sm">
                        <label
                          htmlFor="account-checking"
                          className="font-medium text-base text-gray-700"
                        >
                          Checking
                        </label>
                        <p
                          id="account-checking-description"
                          className="text-gray-500"
                        >
                          CIBC ••••6610
                        </p>
                      </div>
                      <div className="ml-3 flex items-center h-5">
                        <input
                          id="account-checking"
                          aria-describedby="account-checking-description"
                          name="account"
                          type="radio"
                          checked
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        />
                      </div>
                    </div>

                    <div className="relative flex items-start py-4">
                      <div className="min-w-0 flex-1 text-sm">
                        <label
                          htmlFor="account-savings"
                          className="font-medium text-base text-gray-700"
                        >
                          Savings
                        </label>
                        <p
                          id="account-savings-description"
                          className="text-gray-500"
                        >
                          Bank of America ••••0149
                        </p>
                      </div>
                      <div className="ml-3 flex items-center h-5">
                        <input
                          id="account-savings"
                          aria-describedby="account-savings-description"
                          name="account"
                          type="radio"
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        />
                      </div>
                    </div>

                    <div className="relative flex items-start py-4">
                      <div className="min-w-0 flex-1 text-sm">
                        <label
                          htmlFor="account-mastercard"
                          className="font-medium text-base text-gray-700"
                        >
                          Mastercard
                        </label>
                        <p
                          id="account-mastercard-description"
                          className="text-gray-500"
                        >
                          Capital One ••••7877
                        </p>
                      </div>
                      <div className="ml-3 flex items-center h-5">
                        <input
                          id="account-mastercard"
                          aria-describedby="account-mastercard-description"
                          name="account"
                          type="radio"
                          className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div> */}
            {/* <div className="title-h2 mb-2 space-x-2">
              <span>Advanced options</span>
              <span className="badge badge-gray">optional</span>
            </div> */}
            {/* <div className="space-y-2">
              <div className="label">Custom invoice fields</div>
              <div className="text-sm text-gray-500">
                Custom invoice fields let you include extra information, such as
                a purchase order number, in the header of an invoice PDF.{' '}
                <a href="/">Learn more</a>
              </div>
              <div className="grid grid-cols-2 gap-3 w-2/3">
                <div>
                  <FormInput placeholder="Field name (e.g. PO number)" />
                </div>
                <div>
                  <FormInput placeholder="Field value" />
                </div>
                <div className="col-span-2">
                  <Button link>Add custom field</Button>
                </div>
              </div>
            </div> */}
            {/* <div className="space-y-2">
              <div className="label">Footer</div>
              <div className="flex items-center space-x-2">
                <div className="value-text">Footer value here...</div>
                <Button link size="xs">
                  <HiPencil className="w-4 h-4 flex-shrink-0" />
                </Button>
              </div>
              <div className="w-1/2">
                <FormTextArea placeholder="Footer here..." />
              </div>
            </div> */}
          </div>
        </Card>
        <Card label="Preview" className="col-span-2">
          <div className="p-5">
            <div className="text-gray-500">
              Change how this page looks in branding settings.
            </div>
            <div className="bg-gray-200 rounded-md p-10 mt-5">
              <div className="bg-gray-50 p-5 rounded-md shadow-primary-xl">
                <div className="space-y-2">
                  <img src={logo} alt="" className="w-32 mx-auto" />
                  <div className="flex items-center justify-between space-x-2 border-t-4 pt-2">
                    <div className="title-h1">₱210.00</div>
                    <span className="badge badge-gray">Initial</span>
                  </div>
                  <div className="grid grid-cols-3 gap-2 w-52">
                    <div className="text-gray-500 col-span-1 text-sm">To:</div>
                    <div className="text-sm col-span-2">John Doe</div>
                    <div className="text-gray-500 col-span-1 text-sm">
                      From:
                    </div>
                    <div className="text-sm col-span-2">MSYS_TEST_BILLER</div>
                    <div className="text-gray-500 col-span-1 text-sm">
                      Memo:
                    </div>
                    <div className="text-sm col-span-2">Your memo here</div>
                  </div>
                </div>
                <div className="h-1 bg-gray-200 my-4" />
                <div className="text-gray-500 mb-2">Invoice #1324900-898</div>
                <div className="space-y-2 divide-y divide-dashed">
                  <div className="flex items-center justify-between space-x-2 py-2">
                    <div className="text-gray-500">Amount</div>
                    <div className="label">₱200.00</div>
                  </div>
                  <div className="flex items-center justify-between space-x-2 py-2">
                    <div className="text-gray-500">Convenience Fee</div>
                    <div className="label">₱10.00</div>
                  </div>
                  <div className="flex items-center justify-between space-x-2 py-2">
                    <div className="text-gray-500">Total Amount</div>
                    <div className="label">₱210.00</div>
                  </div>
                </div>
                <div className="h-1 bg-gray-200 my-4" />
                <div className="text-sm mt-2 mb-4">Payment Method</div>
                <div className="grid grid-cols-3 gap-2">
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-400 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-900 text-xs">Cash Payments</div>
                  </div>
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-200 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-400 text-xs">Banks</div>
                  </div>
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-200 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-400 text-xs">eWallet</div>
                  </div>
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-200 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-400 text-xs">
                      Visa / Mastercard
                    </div>
                  </div>
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-200 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-400 text-xs">Online Banking</div>
                  </div>
                  <div className="flex flex-col space-y-1 p-2 border-2 border-gray-200 rounded-md bg-white">
                    <div className="w-6 h-6 flex-shrink-0">
                      <img
                        src={placeholder}
                        className="object-contain rounded-md"
                        alt=""
                      />
                    </div>
                    <div className="text-gray-400 text-xs">Kiosk</div>
                  </div>
                </div>
                <div className="my-3 pt-3">
                  <div className="text-xs text-center text-gray-500">
                    By clicking <b>Pay Now</b>, you agree with{' '}
                    <span className="underline">Terms of Service</span> and{' '}
                    <span className="underline">Data Privacy</span>
                  </div>
                </div>
                <div className="mt-4 py-3 bg-primary-500 text-white text-sm font-semibold text-center rounded-md flex items-center space-x-2 justify-center shadow-primary-md">
                  <span>Pay Now</span>
                  <HiLockClosed className="w-4 h-4 flex-shrink-0" />
                </div>
              </div>
              <div className="text-center mt-4 text-2xs mb-3">
                <div className="text-xs text-gray-400">
                  Powered by [Merchant Name]
                </div>
                <div className="text-xs text-gray-400">
                  &copy; 2021 All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

SelectedInvoice.propTypes = {
  onGoBack: PropTypes.func.isRequired,
};

export default SelectedInvoice;
